import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

// 1) Словари (дополнять по мере надобности)
const dict = {
  ru: {
    meta: { langName: "Рус", other: "Eng" },
    nav: {
      about: "Обо мне",
      skills: "Перки и абилки",
      projects: "Рабочие проекты",
      pet: "Пет-проекты",
      contact: "Контакты",
    },
    hero: {
      badge: "Портфолио гейм-дизайнера",
      title: "Создаю уютные игровые миры, где главное - фан игрока.",
      lead: "Реализация игровых систем и проектирование миров. От кубиков до полноценного игрового опыта.",
    },
    about: {
      h2: "Обо мне",
      card: {
        name: "Имя",
        lvl: "Lvl",
        class: "Класс",
        sub: "Саб-класс",
        exp: "EXP",
      },
      p1: "Вот уже более 10 лет моя душа принадлежит геймдеву. Начав свой путь с тестировщика, я в итоге нашла свое призвание в гейм дизайне. И на текущий момент мои навыки имеют уровень сеньора.",
      p2: "За свой путь я не только выросла как гд, но успела побывать на таких позициях как лид, ментор, начинающий хэд и даже немножечко продюсер. Участвовала в разработке как старых проектов с большой ЦА, так и в разработке проекта с нуля. Я всегда стараюсь улучшить свои знания в создании игр, занимаясь самообучением и расширением своего кругозора.",
      p3: "Игры - моя страсть. Мне интересны многие жанры игр, всегда слежу за новостям в мире гейм дева. Я занимаюсь разработкой игр не только для работы, но и в качестве хобби.",
    },
    skills: {
      h2: "Перки и абилки",
      active: {
        title: "Активные абилки",
        items: [
          "Документирование гейм-дизайна: GDD, ТЗ, описание систем",
          "Системный дизайн и балансировка",
          "Левел-дизайн, UX-флоу и структура уровней",
          "Быстрое прототипирование и эксперимент",
          "Конфигурации, настройка игровых параметров",
          "Анализ рынка и игровых трендов",
          "Деконструкция существующих игр",
          "Сбор, анализ и внедрение фидбека с плейтестов",
        ],
      },
      passive: {
        title: "Пассивные перки",
        items: [
          "Веду команду к результату, не теряя смысла",
          "Превращаю идеи в понятные форматы",
          "Управляю временем, не жертвуя качеством",
          "Наставляю гейм-дизайнеров",
          "Слушаю игрока, чувствую проект",
          "Разбираю сложное на логичные части",
          "Быстро подстраиваюсь под изменения",
        ],
      },
      inv: {
        title: "Инвентарь",
        items: [
          "Unity, Unreal, Ink, Fungus",
          "Google Docs, Google Sheets, Miro, Figma",
          "Blender",
          "Coda, Confluence, Figma, Trello, Notion",
        ],
      },
    },
    projects: {
      h2: "Рабочие проекты",
      list: [
        {
          title: "Лифт",
          company: "Fantastic Signals",
          position: "Lead Game Designer",
          period: "09/2023 – 10/2025",
          gameDesc:
            "Симулятор от первого лица, вдохновленный советской фантастикой (в особенности работами братьев Стругацких), в котором увлекательный ремонтный геймплей переплетается с загадочным сюжетным приключением.",
          link: "https://store.steampowered.com/app/3283240/?snr=1_5_9__205",
          responsibilities: [
            "Документация - написание высокоуровневой документации по вижену игры",
            "Прототипирование - создание прототипов механик на бумаге и грейбоксе",
            "Переработка кора игры - концептирование, прототипирование и баланс основного кора игры",
            "Баланс экономики и флоу прохождения уровня",
            "Планирование - создание скоупа задач на основе вижена проекта с учетом сроков и целей текущего этапа разработки",
            "Курирование работы остальных гейм дизайнеров и интеграция их фичей в игру",
          ],
          video: "https://www.youtube.com/embed/h7M_OYzkiBM",
        },
        {
          title: "Untitled",
          company: "Delta Vision Games",
          position: "Senior Game Designer",
          period: "08/2022 - 03/2023",
          gameDesc:
            "Военная тактическая стратегия с Мехами для мобильных устройств.",
          responsibilities: [
            "Фич-овнинг - разработка и написание концептов и скетчей, поиск и анализ референсов",
            "Баланс - расчет баланса боевой системы, создание автоматизированных таблиц для быстрого изменения баланса кора",
            "Переработка кора игры - концептирование, прототипирование и баланс основного кора игры",
            "Прототипирование механик - подготовка прототипов для плейтеста интегрируемых механик",
            "Планирование - создание скоупа задач на основе вижена проекта с учетом сроков и целей текущего этапа разработки",
            "Отрисовка карт - создание карт баз для PvE и PvP-механик в таблицах",
            "Разработка сюжета - основной сюжет, характеры персонажей, диалоги",
          ],
          //image: "/projects/dvg.png",
          video: "https://www.youtube.com/embed/Ke6cQtJQIqo",
        },
        {
          title: "Chibi Island",
          company: "Nexters",
          position: "Lead Game Designer",
          period: "02/2019 - 07/2022",
          gameDesc:
            "Мобильная ферма с элементами приключения на необитаймом острове.",
          responsibilities: [
            "Менеджмент - управление командой ГД, постановка и контроль выполнения задач",
            "Создание гайдов - написание флоу работы по разным направлениям (конфиг, лвл-дизайн, фич-овнинг), гайдов по инструментарию",
            "Онбординг - обучение и интеграция новых сотрудников в команду",
            "Аппрув фичей - контроль и курирование концептов, проверка интеграции перед релизом",
            "Формирование этапов - добавление и распределение задач текущего этапа разработки согласно планам проекта и эффективности ГД-отдела",
            "Создание схем в миро - заведение схем флоу работы для разных направлений (фич-овнинг, отрисовка карт, заведение контента)",
            "Планирование - планирование текущего этапа разработки согласно целям проекта",
          ],
          image: "/projects/chibi.jpg",
        },
        {
          title: "Island Experiment",
          company: "Nexters",
          position: "Game Designer",
          period: "07/2016 - 02/2019",
          gameDesc:
            "Казуальная мобильная игра о группе людей, потерпевших кораблекрушение на таинственном острове.",
          responsibilities: [
            "Разработка концептов для ивента - создание сюжета, описание персонажей",
            "Создание квестов - продумывание и взаимосвязь квестов, баланс, заведение",
            "Разработка и заведение карт (lvl-дизайн) - отрисовка 2D карт в редакторе, расстановка и налаживание объектов",
            "Заведение контента - заведение конфига для работы ивента",
            "Фич-овнинг - ведение фичей от концепта до релиза",
            "Фермерский кор-цикл - создание фермерского кор-цикла на основе рефов с других проектов",
            "Баланс - расчет основного баланса игры",
            "Коммуникация внутри отдела ГД - контроль взаимосвязи всех фичей, создаваемых другими ГД",
            "Обучение - онбординг и обучение новых ГД",
            "Технический дизайн - продумывание и доработка функционала инструментов геймдизайна",
          ],
          image: "/projects/experiment.png",
        },
        {
          title: "Небеса",
          company: "2reallife",
          position: "Game Designer",
          period: "07/2014 - 07/2016",
          gameDesc:
            "Это история о сложных буднях хранителя волшебного острова, его путешествиях и эпических сражениях с монстрами.",
          link: "https://nebogame.online",
          responsibilities: [
            "Разработка концептов для ивента - создание сюжета, описание персонажей",
            "Заведение контента - заведение конфига для работы ивента",
            "Фич-овнинг - ведение фичей от концепта до релиза",
            "Баланс - расчет основного баланса игры для монетизации и боя",
            "Обработка просьб и предложений от пользователей и комьюнити",
          ],
          image: "/projects/nebo.jpg",
        },
      ],
    },
    pet: {
      h2: "Пет-проекты",
      list: [
        {
          title: "Астровентюра: Неизведанная планета",
          desc: "Приключенческая игра с полетами в космосе на самолетах.",
          image: "/projects/astro.png",
          link: "https://store.steampowered.com/app/2464270/Astroventure_Unchartred_Planet/",
        },
        {
          title: "Potion Maker",
          desc: "Расслабляющий симмулятор алхимика, который продает зелья.",
          image: "/projects/potion_maker.png",
          link: "https://creepygarden.itch.io/potion-maker",
        },
        {
          title: "Corsair Conquest",
          desc: "Мобильная игра симмулятор торгового судна в Карибском море во времена пиратства.",
          image: "/projects/corsair.png",
          link: "https://play.google.com/store/apps/details?id=com.CreepyGarden.Pirates",
        },
      ],
    },
    contact: {
      h2: "Контакты",
      email: "Email",
      location: "Локация",
      remote: "Черногория, удалённо",
      linkedin: "LinkedIn",
      github: "Telegram",
    },
    aboutCardValues: {
      name: "Анастасия Поликарова",
      lvl: "34",
      class: "Game Designer",
      sub: "Senior / Lead",
      exp: "12 лет",
    },
  },

  en: {
    meta: { langName: "Eng", other: "Рус" },
    nav: {
      about: "About",
      skills: "Perks & Abilities",
      projects: "Work Projects",
      pet: "Pet Projects",
      contact: "Contacts",
    },
    hero: {
      badge: "Game Designer Portfolio",
      title: "I create cozy game worlds where fun drives the experience.",
      lead: "From core mechanics to complete player experiences — designing systems and worlds that work together.",
    },
    about: {
      h2: "About",
      card: {
        name: "Name",
        lvl: "Lvl",
        class: "Class",
        sub: "Subclass",
        exp: "EXP",
      },
      p1: "For almost 10 years, my heart belongs to game development. Starting as a QA, I found my calling in game design. And now I am a senior.",
      p2: "Over the course of my journey, I have not only grown as a game designer, but have managed to work in positions such as Lead, Mentor, Deputy Head of GD and even Producer. I have participated in the development of projects with a large target audience that have been released before I joined the team (live-ops) and in the development of a project from scratch. I strive to improve my knowledge of game development by constantly self-improving and broadening my horizons.",
      p3: "Videogames are my passion. I am interested in  many different genres of games, and always follow the news about the world of game development. I create games not only as my profession, but also as a hobby.",
    },
    skills: {
      h2: "Perks & Abilities",
      active: {
        title: "Active Abilities",
        items: [
          "Game Design Documentation: GDDs, specs, and system descriptions",
          "Systems Design & Balancing",
          "Level Design, UX Flow & Level Structure",
          "Rapid Prototyping & Experimentation",
          "Game Configuration & Parameter Tuning",
          "Market & Game Trend Analysis",
          "Game Deconstruction & Competitive Research",
          "Playtest Feedback Collection, Analysis & Integration",
        ],
      },
      passive: {
        title: "Passive Perks",
        items: [
          "Lead the team toward results without losing focus",
          "Turn ideas into clear, actionable formats",
          "Manage time without compromising quality",
          "Mentor game designers",
          "Listen to players, understand the project",
          "Break down complexity into logical parts",
          "Adapt quickly to change",
        ],
      },
      inv: {
        title: "Inventory",
        items: [
          "Unity, Unreal, Ink, Fungus",
          "Google Docs, Google Sheets, Miro, Figma",
          "Blender",
          "Coda, Confluence, Figma, Trello, Notion",
        ],
      },
    },
    projects: {
      h2: "Work Projects",
      list: [
        {
          title: "THE LIFT",
          company: "Fantastic Signals",
          position: "Lead Game Designer",
          period: "09/2023 – 10/2025",
          gameDesc:
            "A first-person simulator influenced by Soviet-era science fiction, where immersive repair gameplay meets a mysterious narrative adventure.",
          link: "https://store.steampowered.com/app/3283240/?snr=1_5_9__205",
          responsibilities: [
            "Documentation – writing high-level documentation based on the game vision",
            "Prototyping – creating gameplay mechanic prototypes on paper and in greybox",
            "Core gameplay redesign – concepting, prototyping, and balancing the main game loop",
            "Economy and level flow balancing",
            "Planning – building a task scope based on the project vision, considering timelines and current development goals",
            "Curation – supervising other game designers’ work and integrating their features into the game",
          ],
          video: "https://www.youtube.com/embed/h7M_OYzkiBM",
        },
        {
          title: "Untitled",
          company: "Delta Vision Games",
          position: "Senior Game Designer",
          period: "08/2022 - 03/2023",
          gameDesc:
            "A mobile tactical strategy game centered around mech combat.",
          responsibilities: [
            "Feature ownership – developing and writing feature concepts and sketches, researching and analyzing references",
            "Balancing – calculating combat system balance, creating automated spreadsheets for quick core balance adjustments",
            "Core gameplay redesign – concepting, prototyping, and balancing the main game loop",
            "Mechanic prototyping – preparing prototypes for playtests of integrated mechanics",
            "Planning – building a task scope based on the project vision, considering timelines and current development goals",
            "Map design – creating base layouts for PvE and PvP mechanics using spreadsheets",
            "Story development – main storyline, character concepts, and dialogues",
          ],
          //image: "/projects/dvg.png",
          video: "https://www.youtube.com/embed/Ke6cQtJQIqo",
        },
        {
          title: "Chibi Island",
          company: "Nexters",
          position: "Lead Game Designer",
          period: "02/2019 - 07/2022",
          gameDesc: "A mobile farming adventure set on a deserted island.",
          responsibilities: [
            "Management – leading the game design team, assigning and tracking task completion",
            "Guide creation – writing workflow guides for different directions (config, level design, feature ownership) and documentation for tools",
            "Onboarding – training and integrating new team members",
            "Feature approval – reviewing and supervising concepts, verifying integration before release",
            "Milestone structuring – defining and distributing tasks for the current development phase according to project plans and GD team efficiency",
            "Miro flowcharts – creating workflow diagrams for various areas (feature ownership, map layout, content implementation)",
            "Planning – organizing the current development stage in line with project goals",
          ],
          image: "/projects/chibi.jpg",
        },
        {
          title: "Island Experiment",
          company: "Nexters",
          position: "Game Designer",
          period: "07/2016 - 02/2019",
          gameDesc:
            "A casual mobile game about survivors of a shipwreck exploring a mysterious island.",
          responsibilities: [
            "Event concept development – creating event storylines and character descriptions",
            "Quest design – planning quest logic and interconnections, balancing, and implementation",
            "Map development (level design) – creating 2D maps in the editor, placing and configuring objects",
            "Content setup – configuring data required for event functionality",
            "Feature ownership – managing features from concept to release",
            "Farming core loop – designing the farming core gameplay based on references from other projects",
            "Balancing – calculating the main game balance",
            "Internal GD communication – maintaining consistency across all features developed by the game design team",
            "Training – onboarding and mentoring new game designers",
            "Technical design – planning and refining the functionality of game design tools",
          ],
          image: "/projects/experiment.png",
        },
        {
          title: "Heaven",
          company: "2reallife",
          position: "Game Designer",
          period: "07/2014 - 07/2016",
          gameDesc:
            "The story of a magical island’s guardian, his adventures, and epic fights with monsters.",
          link: "https://nebogame.online",
          responsibilities: [
            "Event concept development – creating event storylines and character descriptions",
            "Content setup – configuring data required for event functionality",
            "Feature ownership – managing features from concept to release",
            "Balancing – calculating core game balance for monetization and combat systems",
            "Community feedback handling – processing player requests and suggestions",
          ],
          image: "/projects/nebo.jpg",
        },
      ],
    },
    pet: {
      h2: "Pet Projects",
      list: [
        {
          title: "Astroventure: Unchartred Planet",
          desc: "An adventure game with airplane exploration across space.",
          image: "/projects/astro.png",
          link: "https://store.steampowered.com/app/2464270/Astroventure_Unchartred_Planet/",
        },
        {
          title: "Potion Maker",
          desc: "A relaxing simulation game where you run an alchemist’s shop and sell potions.",
          image: "/projects/potion_maker.png",
          link: "https://creepygarden.itch.io/potion-maker",
        },
        {
          title: "Corsair Conquest",
          desc: "A mobile simulation game about commanding a trading ship in the Caribbean at the height of piracy.",
          image: "/projects/corsair.png",
          link: "https://play.google.com/store/apps/details?id=com.CreepyGarden.Pirates",
        },
      ],
    },
    contact: {
      h2: "Contacts",
      email: "Email",
      location: "Location",
      remote: "Montenegro, remote",
      linkedin: "LinkedIn",
      github: "Telegram",
    },
    aboutCardValues: {
      name: "Anastasiia Polikarova",
      lvl: "34",
      class: "Game Designer",
      sub: "Senior / Lead",
      exp: "12 years",
    },
  },
};

// 2) Контекст
const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => dict[lang], [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside <I18nProvider>");
  return ctx;
}
